// @flow @format
import React, {PureComponent, type Node} from 'react';
import Popover from '../Popover';
import classNames from 'lib/classnames';
import './Drawer.css';

type Props = {
	active: boolean,
	children?: Node,
	onOverlayClick: () => void,
};

type State = {
	width: number,
	translationX: number,
};

class Drawer extends PureComponent<Props, State> {
	props: Props;
	state: State;

	_width: number;
	_drawer: HTMLElement;
	_updateDimensions: () => void;
	_handleClick: (event: Event) => void;

	state = {
		width: 0,
		translationX: 0,
	};

	componentDidMount() {
		this._updateDimensions();
	}

	componentWillMount() {
		window.addEventListener('resize', this._updateDimensions);
		this.setState({translationX: this.props.active ? 0 : 100});
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this._updateDimensions);
	}

	componentWillReceiveProps(nextProps: Props) {
		if (nextProps.active !== this.props.active) {
			this.setState({translationX: nextProps.active ? 0 : 100});
		}
	}

	shouldComponentUpdate(nextProps: Props) {
		return this.props.active !== nextProps.active;
	}

	_handleClick = (event: SyntheticEvent<>) => {
		this.props.onOverlayClick();
	};

	_updateDimensions = () => this.setState({width: window.innerWidth});

	render(): ?React$Element<any> {
		const {children, active} = this.props;

		const drawerStyle = {
			transform: `translateX(${this.state.translationX}%)`,
		};

		return (
			<Popover>
				<section
					className={classNames({
						Overlay: true,
						'Overlay--Active': active,
						'theme-light': true,
					})}
				>
					<div
						onClick={this._handleClick}
						className="Overlay__Backdrop"
					/>
					<div style={drawerStyle} className="Drawer">
						{children}
					</div>
				</section>
			</Popover>
		);
	}
}

export default Drawer;



// WEBPACK FOOTER //
// ./src/components/Drawer/Drawer.js